<template>
    <v-modal-validated title="Editar información del usuario"
                       accept-button-text="Guardar"
                       close-button-text="Cerrar"
                       :rules="rules"
                       id="edit-users-modal"
                       @closed="closeModal"
                       @accepted="editUser">

        <div class="user-form row">
            <div class="form-group col-6">
                <label>Nombre:</label>
                <Field type="text" name="name" class="form-control" v-model="user.name"/>

                <ErrorMessage name="name"/>
            </div>

            <div class="form-group col-6">
                <label>Email:</label>
                <Field type="email" name="email" class="form-control" v-model="user.email"/>

                <ErrorMessage name="email"/>
            </div>

            <div class="form-group col-6">
                <label>Rol:</label>

                <Field type="text" name="role" class="form-control" v-model="user.role.name">
                    <select class="form-select" name="role" aria-label="Rol" v-model="user.role.name">
                        <option :value="role.name" v-for="role in availableRoles">
                            {{ formatRoleName(role.name) }}
                        </option>
                    </select>
                </Field>

                <ErrorMessage name="role"/>
            </div>

            <div class="form-group col-6">
                <label>Contraseña:</label>
                <Field type="text" name="password" class="form-control" v-model="user.password"/>

                <ErrorMessage name="password"/>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <span class="badge bg-dark"
                      v-if="user.role.name === 'administrador' && window.user.id === user.id">No puedes quitarte el rol de administrador a ti mismo</span>
            </div>

            <div class="col-6">
                <span class="badge bg-dark"
                      v-if="!user.password">Dejar la contraseña en blanco hará que esta no cambie.</span>

                <span class="badge bg-success" v-if="!!user.password && user.password.length >= 3">Esta será la nueva contraseña</span>

                <span class="badge bg-warning"
                      v-if="!!user.password && user.password.length < 3">3 caracteres mínimo</span>
            </div>
        </div>
    </v-modal-validated>
</template>

<script>
import {getRoles} from "../../../helpers/requests/RequestsRoles";
import {editUser} from "../../../helpers/requests/RequestsUsers";
import VModalValidated from "../../general/VModalValidated";
import {ErrorMessage, Field, Form} from "vee-validate";
import * as yup from "yup";

export default {
    name: "UsersListEditModal",
    components: {VModalValidated, Form, Field, ErrorMessage},
    props: {
        user: {
            type: Object,
            required: true,
        }
    },
    data() {
        const rules = yup.object({
            name: yup.string().required('Debes incluir un nombre').max(50, 'Debe tener como máximo 50 caracteres'),
            email: yup.string().required('Debes incluir un correo').email('Debes introducir un correo válido'),
            role: yup.string().required('Debes incluir un rol'),
            password: yup.string().nullable()
        });

        return {
            status: 'loading',
            availableRoles: [],
            selectedUser: {},

            rules
        }
    },
    mounted() {
        this.loadAvailableRoles();
    },
    methods: {
        formatRoleName(name) {
            return name.charAt(0).toUpperCase() + name.slice(1).replaceAll('_', ' ');
        },
        async loadAvailableRoles() {
            // TODO: This is a quick fix to avoid admin delete his own admin role (but can change other admins)
            if (this.user.role.name === 'administrador' && window.user.id === this.user.id) {
                let aux = [];
                aux.push(this.user.role);
                this.availableRoles = aux;
            } else {
                this.availableRoles = await getRoles();
            }
        },
        async editUser(data) {
            // Here comes the information
            // TODO: Maybe make the admin can not change his rol? Avoiding problems...
            try {
                data.id = this.user.id;

                await editUser(data);

                this.$store.dispatch('app/setToastMessage', 'Cambios guardados con éxito');

                this.closeModal();

            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'Error al guardar los cambios');
            }
        },
        closeModal() {
            this.$emit('closed');
        }
    },
    setup() {
        return {
            window
        }
    }
}
</script>
